import React, { useEffect, useState } from "react"
import { TextField } from "@material-ui/core"
import {
  hoursUS,
  minutes,
  timePeriods,
} from "../../../library/utils/timeConvert"
import MenuItem from "@material-ui/core/MenuItem/MenuItem"
import TimeString, {
  createDateString,
} from "../../../library/utils/timeString/timeString"
import withErrorBoundary from "../../../hocs/guards/withErrorBoundary"
import { TimePicker } from "@material-ui/pickers"

const InlineTimePicker = ({
  label = "Time",
  required = true,
  time = "",
  onChange,
  compact = false,
}) => {
  console.log(time)
  const [values, setValues] = useState(TimeString.extractValues(time))

  const handleChange = (name) => (e) => {
    setValues((prevState) => ({ ...prevState, [name]: e.target.value }))
  }

  // useEffect(() => {
  //   if (values.hh && values.mm && values.period) {
  //     const timeString = TimeString.getISOTime(
  //       values.hh,
  //       values.mm,
  //       values.period
  //     )
  //
  //     onChange(TimeString.localToUTC(timeString))
  //
  //     // console.group("Time conversion:")
  //     // console.log("LOCAL: ", timeString)
  //     // console.log("LOCAL -> UTC: ", TimeString.localToUTC(timeString))
  //     // console.groupEnd()
  //   }
  // }, [values.hh, values.mm, values.period])

  const [selectedDate, setSelectedDate] = React.useState(
    new Date(createDateString(time))
  )

  console.log(time, selectedDate)

  const handleDateChange = (date) => {
    setSelectedDate(date)
  }

  const fields = (
    <div className={"form__input"}>
      <TimePicker
        fullWidth
        margin="normal"
        id="time-picker"
        label="Time picker"
        value={selectedDate}
        onChange={handleDateChange}
        KeyboardButtonProps={{
          "aria-label": "change time",
        }}
        showTodayButton
        minutesStep={5}
        // variant={"inline"}
      />
    </div>
  )

  return !compact ? (
    <div className="form__fieldset">
      <span className="form__label">
        {label} {required && "*"}
      </span>
      <div className="form__fieldbox">{fields}</div>
    </div>
  ) : (
    <div>
      <p className={"color-black-54"}>
        {label} {required && "*"}
      </p>
      {fields}
    </div>
  )
}

export default withErrorBoundary(InlineTimePicker)
